import queryString from 'query-string';
import { CurrentPack, PackName } from '~src/interfaces/cycle.interface';
import { routes } from '~src/routingConfig';
import { Uuid } from '~src/services/uuid';
import { getUrlFromObject } from '~src/utils';

export function uriToPack(pathname: string, search: string): CurrentPack|undefined {
  let [emptyString, cycleId] = pathname.split(routes.answerQuestions.cycle + '/');
  const uriSearch = queryString.parse(search);
  if (emptyString !== '' || !Uuid.fromHexStringOrUndefined(cycleId)) {
    if (!uriSearch.lastCycle) {
      return undefined;
    }
    if (Array.isArray(uriSearch.lastCycle)) {
      cycleId = uriSearch.lastCycle[0];
    } else {
      cycleId = uriSearch.lastCycle;
    }
  }

  let packAbout = uriSearch.precedent || uriSearch.packAbout || '';
  if (typeof packAbout === 'string') {
    packAbout = [packAbout];
  }
  let packName = uriSearch.selected_pack || uriSearch.packName || '';
  if (typeof packName === 'string') {
    packName = [packName]
  }

  return {
    packName: packName[0] as PackName,
    packAbout: packAbout[0] || undefined,
    cycleId: cycleId,
  };
}

export function packToUri(params: CurrentPack): string {
  return `${routes.answerQuestions.cycle}/${params.cycleId}` + getUrlFromObject({
    selected_pack: params.packName,
    precedent: params.packAbout,
  });
}

